import { observer } from 'mobx-react-lite';
import type { JSX, ReactNode } from 'react';
import React from 'react';

import { EGoalType, type Goal as GoalModel } from '@feathr/blackbox';

import ConversionPixelTriggerGoal from './ConversionPixelTriggerGoal';
import DonationFormSubmissionGoal from './DonationFormSubmissionGoal';
import FormSubmissionGoal from './FormSubmissionGoal';
import GoalLayout from './GoalLayout';
import GoalV1 from './GoalV1';
import GroupEntryGoal from './GroupEntryGoal';
import URLVisitGoal from './URLVisitGoal';

interface IProps {
  goal: GoalModel;
}

function getContent(goal: GoalModel): ReactNode {
  switch (goal.get('conv_type')) {
    case EGoalType.url_visit:
      return <URLVisitGoal />;

    case EGoalType.form_submission:
      return <FormSubmissionGoal />;

    case EGoalType.donation_form_submission:
      return <DonationFormSubmissionGoal />;

    case EGoalType.custom:
      return <GroupEntryGoal goal={goal} />;

    case EGoalType.conversion_pixel_trigger:
      return <ConversionPixelTriggerGoal goal={goal} />;

    default:
      return null;
  }
}

function Goal({ goal }: Readonly<IProps>): JSX.Element {
  return <GoalLayout goal={goal}>{getContent(goal)}</GoalLayout>;
}

Goal.V1 = GoalV1;

export default observer(Goal);
